import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getMessageV2ReadReceiptQuery,
  getMessageReadReceiptQuery,
} from "./Queries";

export const getMessageV2ReadReceiptFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getMessageV2ReadReceiptQuery,
      variables,
    });

    return _.get(queryData, "node", {});
  } catch (err) {
    return {};
  }
};

export const getMessageReadReceiptFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getMessageReadReceiptQuery,
      variables,
    });

    return _.get(queryData, "node", {});
  } catch (err) {
    return {};
  }
};
